export default "__VITE_ASSET__c8e0f244__"